import { useQuery } from "@tanstack/react-query";

import { supabase } from "@/integrations/supabase/client";

interface MomentumData {
  momentum_score: number;
  momentum_level: "high" | "medium" | "low";
  last_activity_at: string;
  days_since_activity: number;
  session_count: number;
  recent_session_count: number;
  message_count: number;
  memory_count: number;
}

export const useProjectMomentum = (projectId: string | undefined) => {
  const {
    data: momentum,
    isLoading: loading,
    refetch,
  } = useQuery<MomentumData | null>({
    queryKey: ["projectMomentum", projectId],
    queryFn: async () => {
      if (!projectId) return null;

      const { data, error } = await supabase.rpc("calculate_project_momentum", {
        p_project_id: projectId,
      });

      if (error) {
        console.error("Error fetching project momentum:", error);
        throw error; // React Query will handle this
      }

      return data as unknown as MomentumData;
    },
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  return { momentum: momentum || null, loading, refetch };
};
